<template>
  <div>
    <van-form>
      <van-field
        input-align="right"
        v-model="formData.Amount"
        label="主营业务收入"
        placeholder="请输入金额"
        :rules="[{ required: true }]"
      />
      <van-field
        input-align="right"
        readonly
        clickable
        name="picker"
        v-model="formData.Log"
        label="客户"
        placeholder="请选择"
        @click="showCompany = true"
      />
      <van-field
        input-align="right"
        readonly
        clickable
        v-model="formData.AffirmDate"
        label="收入确认日期"
        placeholder="请选择"
        @click="showConfirmDate = true"
      />
      <van-field
        input-align="right"
        readonly
        clickable
        v-model="formData.Datec"
        label="收入截止日期"
        placeholder="请选择"
        @click="showOverDate = true"
      />
      <van-field
        input-align="right"
        readonly
        clickable
        v-model="formData.Currency"
        label="货币"
        placeholder="请选择"
        @click="showCurrency = true"
      />
      <van-field
        input-align="right"
        readonly
        clickable
        v-model="formData.TaxationTypeName"
        label="税种"
        placeholder="请选择"
        @click="showTax = true"
      />
      <van-field
        input-align="right"
        readonly
        clickable
        v-model="formData.RPTypeName"
        label="收款方式"
        placeholder="请选择"
        @click="showFundCategory = true"
      />
      <van-field
        input-align="right"
        readonly
        clickable
        v-model="formData.subcategoryName"
        label="收款子类"
        placeholder="请选择"
        @click="showBankInfo = true"
      />
      <van-field
        input-align="right"
        readonly
        clickable
        v-model="formData.InvType"
        label="收入类别"
        placeholder="请选择"
        @click="showPaymentType = true"
      />
      <van-field
        input-align="right"
        readonly
        clickable
        v-model="formData.Business_GUID"
        label="业务单元"
        placeholder="请选择"
        @click="showPaymentType = true"
      />
      <van-field
        input-align="right"
        readonly
        clickable
        v-model="formData.SubBusiness_GUID"
        label="业务子单元"
        placeholder="请选择"
        @click="showPaymentType = true"
      />
      <van-field
        input-align="right"
        v-model="formData.TaxationAmount"
        label="税费金额"
        placeholder="请输入金额"
        :rules="[{ required: true }]"
      />
      <van-field
        input-align="right"
        v-model="formData.SumAmount"
        label="含税总金额"
        placeholder="请输入金额"
        :rules="[{ required: true }]"
      />
      <van-field
        input-align="right"
        v-model="formData.InvNo"
        label="合同/发票/凭证号"
        placeholder="请输入摘要"
      />
      <van-field
        input-align="right"
        v-model="formData.Remark"
        rows="4"
        label="摘要/备注"
        type="textarea"
        placeholder="请输入摘要"
      />
    </van-form>
    <div class="mt10">
      <van-button block type="primary" @click="Save">提交</van-button>
    </div>
    <!--客户-->
    <van-popup v-model="showCompany" position="bottom">
      <van-picker
        show-toolbar
        :columns="popupData.companyList"
        @confirm="onCompanyConfirm"
        @cancel="showCompany = false"
      />
    </van-popup>
    <!--收入确认日期-->
    <van-popup v-model="showConfirmDate" position="bottom">
      <van-datetime-picker
        type="date"
        @confirm="onConfirmDateConfirm"
        @cancel="showPaymentDate = false"
      />
    </van-popup>
    <!--收入截止日期-->
    <van-popup v-model="showOverDate" position="bottom">
      <van-datetime-picker
        type="date"
        @confirm="onOverDateConfirm"
        @cancel="showPaymentDate = false"
      />
    </van-popup>
    <!--货币-->
    <van-popup v-model="showCurrency" position="bottom">
      <van-picker
        show-toolbar
        :columns="popupData.currencyList"
        @confirm="onCurrencyConfirm"
        @cancel="showCurrency = false"
      />
    </van-popup>
    <!--税种-->
    <van-popup v-model="showTax" position="bottom">
      <van-picker
        show-toolbar
        :columns="popupData.taxList"
        @confirm="onTaxConfirm"
        @cancel="showCurrency = false"
      />
    </van-popup>
    <!--收款方式-->
    <van-popup v-model="showFundCategory" position="bottom">
      <van-picker
        show-toolbar
        :columns="popupData.fundCategory"
        @confirm="onFundCategoryConfirm"
        @cancel="showFundCategory = false"
      />
    </van-popup>
    <!--收款子类-->
    <van-popup v-model="showBankInfo" position="bottom">
      <van-picker
        show-toolbar
        :columns="popupData.accountList"
        @confirm="onBankInfoConfirm"
        @cancel="showBankInfo = false"
      />
    </van-popup>

    <div class="btn-add" @click="chosePhoto()">智能 <br>输入</div>
  </div>
</template>
<script>
  import {getPartnersAllFun, getBankInfoFun, getPayOrReceivablesTypeFun} from '@/api/payment'
  import {getTaxListTypeFun, getSignatureInfoFun, updateIncomeRecord} from '@/api/income'
  import {getCurrencyApi} from "@/api/regist";
  import {Toast} from 'vant'

  export default {
    data() {
      return {
        formData: {
          Amount: '',//收入金额
          RPer: '',//客户
          Log: '',//客户
          AffirmDate: '',//收入确认日期
          Datec: '',//收入截止日期
          Currency: '',//货币
          TaxationType: '',//税种
          TaxationTypeName: '',//税种名称
          RPType: '',//收款方式
          RPTypeName: '',//收款方式名称
          subcategory: '',//收款子类
          subcategoryName: '',//收款子类名称
          InvType: '主营业务收入',
          Business_GUID: '',//业务单元
          SubBusiness_GUID: '',//业务子单元
          TaxationAmount: '',//税费金额
          SumAmount: '',//含税总金额
          Remark: '',//摘要备注
          InvNo: '',//合同发票
          IE_GUID: '',
          DC_GUID: '',
          DisAmount: 0,
          Log_c: '',
          State: '',
          C_GUID: sessionStorage.getItem('companyId'),
          Creator: sessionStorage.getItem('loginName'),
        },
        popupData: {
          companyList: [],
          taxList: [],
          currencyList: [],
          accountList: [],
          fundCategory: [],
        },
        showCompany: false,
        showConfirmDate: false,
        showOverDate: false,
        showCurrency: false,
        showTax: false,
        showBankInfo: false,
        showFundCategory: false,
      }
    },
    mounted: function () {
      this.getSignature();
      this.getTaxList();
      this.getCustomer();
      this.getCurrency();
      this.getBankInfo();
      this.getPayOrReceivablesType()
    },
    methods: {
      onCompanyConfirm(item) {
        this.showCompany = false;
        this.formData.Log = item.text;
        this.formData.RPer = item.value;
      },
      onConfirmDateConfirm(value) {
        this.showConfirmDate = false;
        this.formData.AffirmDate = this.moment(value).format('YYYY-MM-DD');
      },
      onOverDateConfirm(value) {
        this.showOverDate = false;
        this.formData.Datec = this.moment(value).format('YYYY-MM-DD');
      },
      onCurrencyConfirm(item) {
        this.showCurrency = false;
        this.formData.Currency = item.text;
      },
      onTaxConfirm(item) {
        this.showTax = false;
        this.formData.TaxationType = item.value;
        this.formData.TaxationTypeName = item.text;
      },
      onFundCategoryConfirm(item) {
        this.showFundCategory = false;
        this.formData.RPType = item.value;
        this.formData.RPTypeName = item.text;
      },
      onBankInfoConfirm(item) {
        this.showBankInfo = false;
        this.formData.subcategory = item.value;
        this.formData.subcategoryName = item.text;
      },
      //选择图片
      chosePhoto() {//点击事件选择图片
        var self = this
        this.$wx.chooseImage({
          count: 9, // 默认9
          sizeType: ['original', 'compressed'], // 可以指定是原图还是压缩图，默认二者都有
          sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
          success: function (res) {
            self.readImages(res.localIds);
          }
        })
      },
      //
      async readImages(localIds) {
        for (var i = 0; i < localIds.length; i++) {
          await this.doreadImage(localIds[i], localIds.length, i);
        }
        if (localIds.length > 1) {

        }
      },
      //
      doreadImage(item, length, i) {
        let that = this;
        return new Promise(resolve => {
          that.$wx.getLocalImgData({
            localId: item,
            success: function (res) {
              let localData = res.localData;
              window.console.log(localData);
              resolve("done!");
              if (localData.indexOf('data:image') !== 0) {
                localData = 'data:image/jpeg;base64,' + localData
              }
              let data = new FormData();
              data.append('file', that.dataURLtoBlob(localData))
              data.append('frGuid', '96489F0A-B84F-4B51-A807-C8E0688024DE')
              data.append('TempFileNameFirst', '发票Post')
              data.append('Type', 'Ocr')
              if (length === 1) {
                that.$axios.post('/fmsapi/common/FileUpload', data).then(res => {
                  console.log(res)
                  that.ManCon = JSON.parse(res.data.ImageOcr)
                  console.log(that.ManCon.words_result)
                  that.Amount = that.ManCon.words_result.TotalAmount
                  that.Log = that.ManCon.words_result.PurchaserName
                  that.AffirmDate = (that.ManCon.words_result.InvoiceDate).replace(/年/g, "/").replace(/月/g, "/").replace(/日/g, "");
                  that.Datec = (that.ManCon.words_result.InvoiceDate).replace(/年/g, "/").replace(/月/g, "/").replace(/日/g, "");
                  that.InvType = '主营业务收入'
                  that.Remark = that.ManCon.words_result.Remarks
                  that.InvNo = that.ManCon.words_result.SellerRegisterNum
                })
              } else if (length > 1) {
                that.$axios.post('/fmsapi/common/FileUpload', data).then(res => {
                  console.log(res)
                  that.ManCon = JSON.parse(res.data.ImageOcr)//获取到的全部的数据
                  console.log(that.ManCon.words_result)
                  that.incomeinfo.AffirmDate = (that.ManCon.words_result.InvoiceDate).replace(/年/g, "/").replace(/月/g, "/").replace(/日/g, ""),
                    that.incomeinfo.Amount = that.ManCon.words_result.TotalAmount,
                    that.incomeinfo.Log = that.ManCon.words_result.PurchaserName,
                    that.incomeinfo.Date = (that.ManCon.words_result.InvoiceDate).replace(/年/g, "/").replace(/月/g, "/").replace(/日/g, ""),
                    that.incomeinfo.Remark = that.ManCon.words_result.Remarks,
                    that.incomeinfo.InvNo = that.ManCon.words_result.SellerRegisterNum
                  that.incomeList.push(that.incomeinfo)
                  if (i === length - 1) {
                    sessionStorage.setItem("datacon", JSON.stringify(that.incomeList))
                    that.$router.push({path: '/uploadincom'})
                  }

                })

              }

            },
            fail: function (err) {
              window.console.error(err);
            }
          });
        });
      },
      dataURLtoBlob(dataurl) {
        var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
          bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }
        return new Blob([u8arr], {type: mime});
      },
      //提交收入
      async Save() {
        const response = await updateIncomeRecord(this.formData);
        if (response.success) {
          Toast.success('提交成功');
        }
      },
      async getSignature() {
        const response = await getSignatureInfoFun();
        if (response.success) {
          this.$wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: 'wxcbf86100e1590700', // 必填，公众号的唯一标识
            timestamp: response.result.timestamp, // 必填，生成签名的时间戳
            nonceStr: response.result.noncestr, // 必填，生成签名的随机串
            signature: response.result.signature,// 必填，签名
            jsApiList: ['chooseImage', 'getLocalImgData'] // 必填，需要使用的JS接口列表
          });
        }
      },
      //获取到税种的数据
      async getTaxList() {
        const params = {
          C_GUID: this.getCookie('CompanyInfo').companyId
        };
        const response = await getTaxListTypeFun(params);
        if (response.success) {
          response.result.map(item => {
            this.popupData.taxList.push({
              text: item.Name,
              value: item.T_GUID
            })
          });
        }
      },
      //银行账户
      async getBankInfo() {
        const params = {
          cGuid: this.getCookie('CompanyInfo').companyId
        };
        const response = await getBankInfoFun(params);
        if (response.success) {
          const {success, ...otherData} = response;
          Object.values(otherData).map(item => {
            this.popupData.accountList.push({
              text: item.label,
              value: item.value
            })
          })
        }
      },
      //资金类别
      async getPayOrReceivablesType() {
        const params = {
          cGuid: this.getCookie('CompanyInfo').companyId
        };
        const response = await getPayOrReceivablesTypeFun(params);
        if (response.success) {
          const {success, ...otherData} = response;
          Object.values(otherData).map(item => {
            this.popupData.fundCategory.push({
              text: item.label,
              value: item.value,
            })
          })
        }
      },
      async getCustomer() {
        const params = {
          C_GUID: this.getCookie('CompanyInfo').companyId
        };
        const response = await getPartnersAllFun(params);
        if (response.success) {
          response.result.map(item => {
            this.popupData.companyList.push({
              text: item.Name,
              value: item.BP_GUID
            })
          });
        }
      },
      //获取所有的货币
      async getCurrency() {
        const response = await getCurrencyApi();
        if (response.success) {
          console.log(response);
          response.result.map(item => {
            this.popupData.currencyList.push({
              text: item.Code,
              value: item.Code
            })
          });
        }
      },
    }
  }
</script>
<style lang="less" scoped>
  .btn-add {
    position: absolute;
    bottom: 4rem;
    right: 2rem;
    color: white;
    background: #1fb1c4;
    width: 5rem;
    height: 5rem;
    border-radius: 50%;
    display:flex;
    align-items: center;
    justify-content: center;
  }
</style>
